import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

/**
 * Hook to create a guided tour for the Free Schedules page
 * Uses Driver.js to highlight elements and show explanations
 */
export function useFreeSchedulesTour() {
    const { t } = useTranslation();

    const startTour = useCallback(() => {
        const driverObj = driver({
            showProgress: true,
            animate: true,
            allowClose: true,
            stagePadding: 4,
            nextBtnText: t('tour.next'),
            prevBtnText: t('tour.back'),
            doneBtnText: t('tour.last'),
            progressText: '{{current}} / {{total}}',
            steps: [
                {
                    popover: {
                        title: t('tour.freeSchedules.intro.title'),
                        description: t('tour.freeSchedules.intro.description'),
                    },
                },
                {
                    element: '#fab-add-button',
                    popover: {
                        title: t('tour.freeSchedules.addButton.title'),
                        description: t(
                            'tour.freeSchedules.addButton.description',
                        ),
                        side: 'top',
                        align: 'end',
                    },
                },
                {
                    element: 'table tbody tr td:nth-child(2) a',
                    popover: {
                        title: t('tour.freeSchedules.scheduleName.title'),
                        description: t(
                            'tour.freeSchedules.scheduleName.description',
                        ),
                        side: 'bottom',
                        align: 'start',
                    },
                },
                {
                    element: 'input[type="text"]',
                    popover: {
                        title: t('tour.freeSchedules.nameFilter.title'),
                        description: t(
                            'tour.freeSchedules.nameFilter.description',
                        ),
                        side: 'bottom',
                        align: 'start',
                    },
                },
                {
                    element: '#filter-button',
                    popover: {
                        title: t('tour.freeSchedules.filterButton.title'),
                        description: t(
                            'tour.freeSchedules.filterButton.description',
                        ),
                        side: 'bottom',
                        align: 'end',
                    },
                },
            ],
        });

        driverObj.drive();
    }, [t]);

    return { startTour };
}
